// Layout, that contains navBar, header and main content of a page
// Used almost in every page of this project

import React, { Component, ReactNode } from "react";
import { style } from "typestyle";

type IPageLayoutProps = {
  navBar?: JSX.Element;
  header?: JSX.Element;
  content?: JSX.Element | null;
  children?: ReactNode;
};

export default class PageLayout extends Component<IPageLayoutProps> {
  render(): JSX.Element {
    const { navBar, header, content, children } = this.props;
    const cont = content || children;

    return (
      <div
        className={style({
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          flexDirection: "column",
          padding: "64px 0",
        })}
      >
        {navBar && (
          <div
            className={style({
              width: "100%",
              position: "fixed",
              height: "64px",
              top: 0,
              left: 0,
              zIndex: 100500,
            })}
          >
            {navBar}
          </div>
        )}
        {header && (
          <div
            className={style({
              width: "100%",
            })}
          >
            {header}
          </div>
        )}
        {cont && (
          <div
            className={style({
              width: "100%",
              maxWidth: "800px",
              marginTop: "40px",
              paddingBottom: "40px",
            })}
          >
            {cont}
          </div>
        )}
      </div>
    );
  }
}
